import angular from 'angular';
import { AlternateBrandsComponent } from './alternate-brands.component';
import { AlternateBrandsOptionComponent } from './alternate-brands-option';

export const AlternateBrandsModule = angular
  .module('alternate-brands', [])
  .component('updAlternateBrands', AlternateBrandsComponent)
  .component('updAlternateBrandsOption', AlternateBrandsOptionComponent);
